import PayrollCompanyLayout from "../../../components/layouts/PayrollCompanyLayout";
import { Helmet } from "react-helmet-async";
import CustomTaxReliefs from "./views/CustomTaxReliefs";
import {
	PERMISSIONS,
	useValidateUserPermissions,
} from "../../../helpers/usePermissionManager";

const CustomTaxReliefsPage = () => {
	const hasPermission = useValidateUserPermissions(
		[PERMISSIONS.COMPANY_CONFIGS_WRITE, PERMISSIONS.COMPANY_CONFIGS_READ],
		"OR",
	);

	return (
		<>
			{hasPermission && (
				<PayrollCompanyLayout>
					<Helmet>
						<title>Custom Tax Reliefs | Company Flow</title>
					</Helmet>
					<h1 className="font-bold text-xl mb-8">Custom Tax Reliefs</h1>
					<CustomTaxReliefs />
				</PayrollCompanyLayout>
			)}
		</>
	);
};

export default CustomTaxReliefsPage;
